import { Box, ListItemSelect } from '@wix/design-system';
import t__default, { useContext, useMemo } from 'react';
import { RicosContext } from 'ricos-context';
import { PREDEFINED_SPACING_OPTION } from '../../data-hooks.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const PREDEFINED_LINE_HEIGHTS = [
  { text: "1", commandKey: "1" },
  { text: "1.5", commandKey: "1.5" },
  { text: "2", commandKey: "2" },
  { text: "2.5", commandKey: "2.5" },
  { text: "3", commandKey: "3" }
];
const SpacingSelector = ({
  lineSpacing,
  initialLineSpacing,
  onSelectSpacing
}) => {
  const { isMobile } = useContext(RicosContext);
  const options = useMemo(() => {
    const current = lineSpacing["line-height"];
    const isCurrentInOptions = PREDEFINED_LINE_HEIGHTS.some(
      (lineHeight) => lineHeight.text === current
    );
    return isCurrentInOptions ? PREDEFINED_LINE_HEIGHTS : [...PREDEFINED_LINE_HEIGHTS, { text: current, commandKey: current }].sort(
      (a, b) => Number(a.commandKey) - Number(b.commandKey)
    );
  }, [lineSpacing["line-height"]]);
  return /* @__PURE__ */ t__default.createElement(
    Box,
    {
      direction: "vertical",
      gap: "SP1",
      marginTop: "SP2",
      marginBottom: "SP2",
      width: isMobile ? "100%" : "fit-content",
      minWidth: "152px"
    },
    options.map(({ text, commandKey }) => /* @__PURE__ */ t__default.createElement(
      ListItemSelect,
      {
        dataHook: PREDEFINED_SPACING_OPTION,
        key: commandKey,
        title: text,
        selected: initialLineSpacing["line-height"] === commandKey,
        onClick: () => {
          onSelectSpacing(__spreadProps(__spreadValues({}, lineSpacing), { "line-height": commandKey }));
        },
        ellipsis: true,
        size: isMobile ? "medium" : "small"
      }
    ))
  );
};

export { SpacingSelector };
//# sourceMappingURL=spacing-selector.js.map
